import React, { useContext, useEffect, useState } from "react";

import { Preview } from "@creatomate/preview";

import CultureHQVideoStudioIcon from "images/CultureHQ-Video-Studio-Icon.png";
import { Trans, t } from "app/utils";
import { StringField } from "@culturehq/components";
import { useTemplateBuilder } from "components/admin/templates/context/TemplateBuilderContext";
import MediaVersionHistory from "./actions/MediaVersionHistory";
import { CreatomateContext } from "../contexts/VideoStudioContext";
import { VIDEO_TYPE, TEMPLATE_BUILDER_DEFAULT_NAMES } from "../utils/constants";

interface ModalTitleProps {
  preview: Preview;
}

interface StudioTitleProps {
  preview: Preview;
}

const Title: React.FC<{}> = () => (
  <>
    <h2 className="chq-pan--hd__title" id="video-studio-title"><Trans>CultureHQ Studio</Trans></h2>
    <h2 className="chq-pan--hd__title__smaller"><Trans>CHQ Studio</Trans></h2>
  </>
);

const TemplateBuilderTitle = ({ editTitle, title, handleChangeText, handleEditTitle }: any) => {
  if (!editTitle) {
    return (
      <>
        <h2 className="chq-pan--hd__title edit-cursor" id="video-studio-title" onClick={() => handleEditTitle(true)}>
          <Trans>{title}</Trans>
        </h2>
        <h2 className="chq-pan--hd__title__smaller edit-cursor" onClick={() => handleEditTitle(true)}>
          <Trans>{title}</Trans>
        </h2>
      </>
    );
  }

  return (
    <div onBlur={() => handleEditTitle(false)}>
      <StringField
        name="title"
        value={title}
        onChange={handleChangeText}
        onBlur={() => handleEditTitle(false)}
        autoFocus
      >
        <></>
      </StringField>
    </div>
  );
};

const StudioTitle: React.FC<StudioTitleProps> = ({ preview }) => {
  const { data } = useContext(CreatomateContext);
  const { handleState, state: { title }, templateBuilderSelection } = useTemplateBuilder();
  const { mediaType, montage } = data;
  const [editTitle, setEditTitle] = useState(false);

  useEffect(
    () => {
      if (title === "") {
        handleState({ title: templateBuilderSelection === "none" ? "" : TEMPLATE_BUILDER_DEFAULT_NAMES[templateBuilderSelection] });
      }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []
  );

  const handleEditTitle = (value: boolean) => {
    setEditTitle(value);
    if (!value && title === "") {
      handleState({ title: templateBuilderSelection === "none" ? "" : TEMPLATE_BUILDER_DEFAULT_NAMES[templateBuilderSelection] });
    }
  };

  const handleChangeText = (value: any) => {
    handleState({ title: value });
  };

  if (templateBuilderSelection !== "none") {
    return (
      <>
        <TemplateBuilderTitle
          editTitle={editTitle}
          title={title}
          handleChangeText={handleChangeText}
          handleEditTitle={handleEditTitle}
        />
        <MediaVersionHistory preview={preview} />
      </>
    );
  }

  if (montage) return <Title />;

  return (
    <>
      <Title />
      <MediaVersionHistory preview={preview} />
    </>
  );
};

const ModalTitle: React.FC<ModalTitleProps> = ({ preview }) => (
  <div className="chq-pan--hd__logo">
    <img src={CultureHQVideoStudioIcon} alt={t("CHQ Studio")} />
    <div className="video-studio-title-container">
      <StudioTitle preview={preview} />
    </div>
  </div>
);

export default ModalTitle;
